import React, { useState } from 'react';
import { apiClient } from '@/lib/api';
import { useGlobalContext } from '@/contexts/GlobalContext';
import { Button } from '@/components/ui/Button';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/Card';

export const ApiDebug: React.FC = () => {
  const { userData } = useGlobalContext();
  const [testResult, setTestResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const testHealthApi = async () => {
    setLoading(true);
    try {
      console.log('Testing health API...');
      const result = await apiClient.getHealth();
      console.log('Health API result:', result);
      setTestResult({ success: true, data: result });
    } catch (error) {
      console.error('Health API error:', error);
      setTestResult({ success: false, error });
    } finally {
      setLoading(false);
    }
  };

  const testUserProfileApi = async () => {
    setLoading(true);
    try {
      console.log('Testing user profile API...');
      const result = await apiClient.getUserProfile();
      console.log('User profile API result:', result);
      setTestResult({ success: true, data: result });
    } catch (error) {
      console.error('User profile API error:', error);
      setTestResult({ success: false, error });
    } finally {
      setLoading(false);
    }
  };

  const testLeaderboardApi = async () => {
    setLoading(true);
    try {
      console.log('Testing leaderboard API...');
      const result = await apiClient.getLeaderboard();
      console.log('Leaderboard API result:', result);
      setTestResult({ success: true, data: result });
    } catch (error) {
      console.error('Leaderboard API error:', error);
      setTestResult({ success: false, error });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>API Debug Panel</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div>
              <h3 className="font-semibold mb-2">User Data:</h3>
              <pre className="bg-gray-100 p-3 rounded text-sm overflow-auto">
                {JSON.stringify(userData, null, 2)}
              </pre>
            </div>

            <div>
              <h3 className="font-semibold mb-2">API Tests:</h3>
              <div className="flex space-x-4">
                <Button onClick={testHealthApi} disabled={loading}>
                  Test Health API
                </Button>
                <Button onClick={testUserProfileApi} disabled={loading}>
                  Test User Profile API
                </Button>
                <Button onClick={testLeaderboardApi} disabled={loading}>
                  Test Leaderboard API
                </Button>
              </div>
            </div>

            {testResult && (
              <div>
                <h3 className="font-semibold mb-2">Test Result:</h3>
                <pre className="bg-gray-100 p-3 rounded text-sm overflow-auto">
                  {JSON.stringify(testResult, null, 2)}
                </pre>
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}; 